import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import BookCard from "@/components/BookCard";
import Footer from "@/sections/Footer";
import { Eyebrow, MaskedLine } from "@/components/Reveal";
import { BOOKS } from "@/data/books";

export default function BooksPage() {
  return (
    <div className="grain">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <Eyebrow className="mb-5">The Collection</Eyebrow>
            <h1 className="font-display font-extrabold tracking-tight leading-[1.08] text-4xl sm:text-5xl lg:text-6xl text-walnut">
              <MaskedLine i={0}>The Bailey</MaskedLine>
              <MaskedLine i={1}>book series</MaskedLine>
            </h1>
            <p className="mt-6 max-w-xl text-base sm:text-lg text-walnutsoft leading-relaxed">
              Five adventures written by Damali Allison and illustrated by Meni Etim.
              Add your favourites to the basket, then check out securely on Amazon UK.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {BOOKS.map((book, i) => (
              <BookCard key={book.slug} book={book} delay={(i % 3) * 0.1} />
            ))}
          </div>
        </div>
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
